import { render } from "./NewBrokerSftpConfigurationModal.vue?vue&type=template&id=3d922663&ts=true"
import script from "./NewBrokerSftpConfigurationModal.vue?vue&type=script&lang=ts"
export * from "./NewBrokerSftpConfigurationModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__